import { db } from '../db';
import type { ProtocolRecord } from '../types';
import { dotProbeProtocolSchema } from '@/domain/core/protocol.schema';
import builtin from '../../../protocols/dot-probe-anxiety-v1.protocol.json';

export async function sha256Json(raw: unknown): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(raw)));
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

/** 스키마 검증 후 등록. 같은 key 가 있으면 그것을 돌려준다 (내용이 달라도 덮어쓰지 않는다 — 버전을 올려야 한다). */
export async function registerProtocol(raw: unknown, source: ProtocolRecord['source']): Promise<ProtocolRecord> {
  const parsed = dotProbeProtocolSchema.parse(raw);
  const key = `${parsed.id}@${parsed.version}`;
  const existing = await db.protocols.where('key').equals(key).first();
  if (existing) return existing;
  const rec: ProtocolRecord = {
    id: crypto.randomUUID(), key, protocolId: parsed.id, version: parsed.version, name: parsed.name,
    task: 'CBM_A', raw, hash: await sha256Json(raw), source, createdAt: new Date().toISOString(),
  };
  await db.protocols.add(rec);
  return rec;
}

/** 부팅 시 저장소의 기본 프로토콜을 등록한다. 멱등. */
export async function seedBuiltinProtocols(): Promise<void> {
  await registerProtocol(builtin, 'builtin');
}

export const listProtocols = () => db.protocols.orderBy('createdAt').toArray();
export const getProtocolByKey = (key: string) => db.protocols.where('key').equals(key).first();
export const deleteProtocol = (id: string) => db.protocols.delete(id);
export const BUILTIN_KEY = `${(builtin as { id: string }).id}@${(builtin as { version: string }).version}`;
